import { handleActions, createAction } from "redux-actions";
import { api } from "../../services";
import { rootReducerInterface } from "../../typings/interfaces";

const SYSTEM_MESSAGES_GET = "SYSTEM_MESSAGES_GET";
const SYSTEM_MESSAGE_GET = "SYSTEM_MESSAGE_GET";
const SYSTEM_MESSAGE_UNREAD_COUNT_GET = "SYSTEM_MESSAGE_UNREAD_COUNT_GET";
const SYSTEM_MESSAGES_DELETE = "SYSTEM_MESSAGES_DELETE";
const SYSTEM_MESSAGE_SET_PROMPT_CHOICE = "SYSTEM_MESSAGE_SET_PROMPT_CHOICE";
const SYSTEM_MESSAGE_CLEAR = "SYSTEM_MESSAGE_CLEAR";

export interface SystemMessageI {
  id: string;
  senderName: string;
  title: string;
  content: string;
  preview: string;
  isRead: boolean;
  createdAt: string;
  type: number;
  promptChoice: boolean | null;
  yesPromptChoiceLabel: string;
  noPromptChoiceLabel: string;
}

export interface SystemMessageStateI {
  messages: SystemMessageI[];
  selectedMessage: SystemMessageI | null;
  unreadCount: number;
  pagination: {
    currentPage: number;
    count: number;
  } | null;
}

// Actions
export const getSystemMessages = createAction(
  SYSTEM_MESSAGES_GET,
  async (params?: any, callback?: Function) => {
    try {
      const response = await api.SystemMessage.getMessages(params);
      callback && callback(response);
      return response;
    } catch (error) {
      callback && callback(null, error);
      throw error;
    }
  }
);

export const getSystemMessage = createAction(
  SYSTEM_MESSAGE_GET,
  async (id: string, callback?: Function) => {
    try {
      const response = await api.SystemMessage.getMessage(id);
      callback && callback(response);
      return response;
    } catch (error) {
      callback && callback(null, error);
      throw error;
    }
  }
);

export const getSystemMessageUnreadCount = createAction(
  SYSTEM_MESSAGE_UNREAD_COUNT_GET,
  async (callback?: Function) => {
    try {
      const response = await api.SystemMessage.getUnreadCount();
      callback && callback(response);
      return response;
    } catch (error) {
      callback && callback(null, error);
      throw error;
    }
  }
);

export const deleteSystemMessages = createAction(
  SYSTEM_MESSAGES_DELETE,
  async (ids: string[], callback?: Function) => {
    try {
      await api.SystemMessage.deleteMessages(ids);
      callback && callback(true);
      return { ids };
    } catch (error) {
      callback && callback(false, error);
      throw error;
    }
  }
);

export const setPromptChoice = createAction(
  SYSTEM_MESSAGE_SET_PROMPT_CHOICE,
  async (id: string, promptChoice: boolean, callback?: Function) => {
    try {
      await api.SystemMessage.setPromptChoice(id, promptChoice);
      callback && callback(true);
      return { id, promptChoice };
    } catch (error) {
      callback && callback(false, error);
      throw error;
    }
  }
);

export const clearSystemMessage = createAction(SYSTEM_MESSAGE_CLEAR);

// Selectors
export const selectSystemMessages = (state: rootReducerInterface) => state.systemMessage.messages;
export const selectSystemMessage = (state: rootReducerInterface) => state.systemMessage.selectedMessage;
export const selectSystemMessageUnreadCount = (state: rootReducerInterface) => state.systemMessage.unreadCount;
export const selectSystemMessagePagination = (state: rootReducerInterface) => state.systemMessage.pagination;

// Reducer
const initialState: SystemMessageStateI = {
  messages: [],
  selectedMessage: null,
  unreadCount: 0,
  pagination: null,
};

export default handleActions(
  {
    [SYSTEM_MESSAGES_GET]: (state: SystemMessageStateI, { payload }) => ({
      ...state,
      messages: payload && payload.data ? payload.data : [],
      pagination: {
        currentPage: payload && payload.currentPage ? payload.currentPage : 1,
        count: payload && payload.count ? payload.count : 0,
      },
    }),
    [SYSTEM_MESSAGE_GET]: (state: SystemMessageStateI, { payload }) => ({
      ...state,
      selectedMessage: payload || null,
      messages: state.messages.map(msg =>
        msg.id === (payload && payload.id) ? { ...msg, isRead: true } : msg
      ),
    }),
    [SYSTEM_MESSAGE_UNREAD_COUNT_GET]: (state: SystemMessageStateI, { payload }) => ({
      ...state,
      unreadCount: payload && payload.count ? payload.count : 0,
    }),
    [SYSTEM_MESSAGES_DELETE]: (state: SystemMessageStateI, { payload }) => {
      const ids = payload && payload.ids ? payload.ids : [];
      return {
        ...state,
        selectedMessage: state.selectedMessage && ids.includes(state.selectedMessage.id) ? null : state.selectedMessage,
        messages: state.messages.filter(msg => !ids.includes(msg.id)),
      };
    },
    [SYSTEM_MESSAGE_CLEAR]: (state: SystemMessageStateI) => ({
      ...state,
      selectedMessage: null,
    }),
  },
  initialState
);



// WEBPACK FOOTER //
// ./src/routes/SystemMessage/systemMessage.ducks.ts